// These are tied to mercury SortField and the string values cannot be changed.
export enum SortFieldEnum {
    CIRCULATION_UNIQUE_VISITORS = 'CIRCULATION_UNIQUE_VISITORS',
    CIRCULATION_CIRCULATION = 'CIRCULATION_CIRCULATION',
    CIRCULATION_FOLLOWERS = 'CIRCULATION_FOLLOWERS',
    CIRCULATION_LISTENERS = 'CIRCULATION_LISTENERS',
    CIRCULATION_VIEWERS = 'CIRCULATION_VIEWERS',
    CIRCULATION_TIER = 'CIRCULATION_TIER',
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    JOB_TITLE = 'JOB_TITLE',
    OUTLET_NAME = 'OUTLET_NAME',
    COUNTRY_NAME = 'COUNTRY_NAME',
    PROVINCE_NAME = 'PROVINCE_NAME',
    CITY_NAME = 'CITY_NAME',
    // Only for limited accounts for the time being
    JOB_ROLE_IMPORTANCE = 'JOB_ROLE_IMPORTANCE'
}
